export const QUICK_CASH_OPEN_VALUE = 'quick-cash-20000';

// 로컬 개발 환경만 리다이렉트 대상에서 제외하며 배포 도메인은 제외하지 않는다.
const LOCAL_HOSTNAMES = new Set([
  'localhost',
  '127.0.0.1',
  '::1',
  '[::1]',
]);

export const isLocalHostname = (hostname) => (
  LOCAL_HOSTNAMES.has((hostname || '').toLowerCase())
);

export const getQuickCashDesktopRedirectUrl = (
  search,
  quickCashDesktopUrl
) => {
  const open = new URLSearchParams(search).get('open');

  // 신규 Quick Cash PC 요청이 아니면 호출부에서 기존 리다이렉트를 실행하도록 null을 반환한다.
  if (open !== QUICK_CASH_OPEN_VALUE || !quickCashDesktopUrl) {
    return null;
  }

  try {
    const redirectUrl = new URL(quickCashDesktopUrl);

    // 환경변수 오설정으로 안전하지 않은 주소에 이동하지 않도록 HTTPS 목적지만 허용한다.
    if (redirectUrl.protocol !== 'https:') {
      return null;
    }

    // 목적지 페이지에서도 상품을 식별할 수 있도록 Quick Cash open 값을 전달한다.
    redirectUrl.searchParams.set('open', QUICK_CASH_OPEN_VALUE);
    return redirectUrl.toString();
  } catch {
    // URL 형식이 잘못된 경우 기존 PC 리다이렉트로 안전하게 복귀한다.
    return null;
  }
};
